import { useEffect, useState } from 'react';

export const useRecaptcha = () => {

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  useEffect(() => {

    if (!siteKey) {
      console.error('siteKey not provided');
      return;
    }

    cleanupStyles();

    // Check script existing
    if (window.grecaptcha?.ready) {
      // just return if it is already loaded
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log('reCAPTCHA script is loaded')
    };

    script.onerror = () => {
      console.error('Failed to load reCAPTCHA script');
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [siteKey]);

  const executeReCaptcha = ( action, callback ) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(siteKey, { action })
      .then((token) => {
        callback(token);
      })
      .catch((err) => {
        console.error(err);
        callback(null);
      });
    });

  };

  const cleanupStyles = () => {
    // Remove styles to hide recaptcha badge
    const style = document.getElementById('recaptcha-hide-style');
    if (style) {
      style.remove();
    }
  };

  const cleanupReCaptcha = () => {
    // Add styles to hide recaptcha badge
    let style = document.getElementById('recaptcha-hide-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'recaptcha-hide-style';
      style.textContent = `
        .grecaptcha-badge {
          visibility: hidden;
        }
      `;
      document.head.appendChild(style);
    }
  };

  return { executeReCaptcha, cleanupReCaptcha };

};